const YourCartHeader = (): JSX.Element => {
  return (
    <div>
      <div className="flex flex-row ">
        <p className="pl-3 text-xl font-black">Your Cart</p>
      </div>
    </div>
  );
};

export default YourCartHeader;
